import { CommonModule } from '@angular/common';
import {
  Component,
  inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  Asset,
  Collection,
  Model,
  Project,
  UserRule,
} from '@verify/shared-components/models';
import { HasRulePipe } from '@verify/shared-components/services';
import { Observable } from 'rxjs';
import { ModelNamePipe } from '../../../pipes';
import {
  AssetSearchService,
  ModelService,
  ProjectService,
} from '../../../services';
import { CollectionService } from '../../../services/asset/collection.service';

@Component({
  selector: 'app-search-results',
  imports: [
    CommonModule,
    TranslateModule,
    ModelNamePipe,
    MatIconModule,
    MatBadgeModule,
    HasRulePipe,
    RouterModule,
  ],
  templateUrl: './search-results.component.html',
  styleUrl: './search-results.component.scss',
})
export class SearchResultsComponent implements OnChanges {
  private projectService = inject(ProjectService);
  private collectionService = inject(CollectionService);
  private modelService = inject(ModelService);
  private assetSearchService = inject(AssetSearchService);
  private router = inject(Router);

  @Input()
  searchValue: string;

  projects$: Observable<{ totalHits: number; projects: Project[] }>;
  collections$: Observable<{ totalHits: number; collections: Collection[] }>;
  models$: Observable<{ totalHits: number; models: Model[] }>;
  assets$: Observable<{ totalHits: number; assets: Asset[] }>;

  UserRule = UserRule;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['searchValue']?.currentValue) {
      this.search();
    }
  }

  onOpenProject(project: Project): void {
    this.router.navigate(['project', project.id]);
  }

  onOpenCollection(collection: Collection): void {
    this.router.navigate(['collection', collection.id]);
  }

  onOpenModel(model: Model): void {
    this.router.navigate(['models'], {
      queryParams: { query: this.searchValue, model: model.id },
    });
  }

  onOpenAsset(asset: Asset): void {
    this.router.navigate(['asset', asset.id]);
  }

  trackById(_: number, { id }: { id?: string }): string {
    return id;
  }

  private search(): void {
    this.projects$ = this.projectService.searchProjects({
      queryString: this.searchValue,
      from: 0,
      size: 4,
    });
    this.collections$ = this.collectionService.searchCollections({
      queryString: this.searchValue,
      from: 0,
      size: 4,
    });
    this.models$ = this.modelService.searchModels({
      queryString: this.searchValue,
      from: 0,
      size: 4,
    });
    this.assets$ = this.assetSearchService.searchAssets({
      queryString: this.searchValue,
      from: 0,
      size: 4,
    });
  }
}
